import React from 'react';
import { Text, View } from 'react-native';
import { calendarStyles } from './calendar.styles';

export interface DayNumberProps {
  /** Day-of-month number to render. */
  day: number;
  /** Render the today treatment (18×18 #020202 circle, white 11/600). */
  isToday?: boolean;
  /** Whether the day belongs to the anchored month (out-of-month → 50% dim). */
  inMonth?: boolean;
}

/**
 * The day-of-month number in a month cell (plan 0017 §1 "Day number").
 * Normal: 12/16 foreground-soft, out-of-month at 50% opacity.
 * Today: 18×18 circle bg #020202, text #FCFCFC 11px weight 600, tabular-nums.
 */
export const DayNumber: React.FC<DayNumberProps> = ({
  day,
  isToday = false,
  inMonth = true,
}) => {
  if (isToday) {
    return (
      <View style={calendarStyles.dayNumberTodayCircle}>
        <Text style={calendarStyles.dayNumberTodayText}>{day}</Text>
      </View>
    );
  }

  return (
    <Text
      style={[
        calendarStyles.dayNumber,
        !inMonth && calendarStyles.dayNumberOutOfMonth,
      ]}
    >
      {day}
    </Text>
  );
};

DayNumber.displayName = 'DayNumber';
